import { render, staticRenderFns } from "./publicityCategoryList.vue?vue&type=template&id=7c2db1eb"
import script from "./publicityCategoryList.vue?vue&type=script&lang=js"
export * from "./publicityCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports